<template>
   <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>  
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Pengiriman Barang</h3>
        <div class="ml-auto">
          
        </div> 
        </div>
        <hr class="custom-hr" />  
        <JqxGrid ref="myGrid" :autorowheight="true" :autoheight="true"
            :width="width" :theme="'material-green'" :selectionmode="'singlerow'" :ready="ready"
            :pageable="false" :sortable="true" :filterable="true" :showfilterrow="true" :columnsresize="true"
            :source="dataAdapter" :columns="columns" @contextmenu="myGridOnContextMenu()" @rowclick="myGridOnRowClick($event)"
        />
        <JqxMenu ref="myMenu" @itemclick="myMenuOnItemClick($event)"
                 :width="200" :height="88" :mode="'popup'" :autoOpenPopup="false">
            <ul>
                <li v-if="canPrint==true">Cetak</li>
            </ul>
        </JqxMenu>
      </vs-card>
     
    </vs-col>
    
   </vs-row>

</template>

<script>
    import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
    import JqxWindow from "jqwidgets-scripts/jqwidgets-vue/vue_jqxwindow.vue";
    import JqxInput from "jqwidgets-scripts/jqwidgets-vue/vue_jqxinput.vue";
    import JqxNumberInput from "jqwidgets-scripts/jqwidgets-vue/vue_jqxnumberinput.vue";
    import JqxButton from "jqwidgets-scripts/jqwidgets-vue/vue_jqxbuttons.vue";
    import JqxMenu from "jqwidgets-scripts/jqwidgets-vue/vue_jqxmenu.vue";
    import qz from "qz-tray";
    
  export default {
    components: {
        JqxGrid,
        JqxWindow,
        JqxInput,
        JqxNumberInput,
        JqxButton,
        JqxMenu
    },
    props: {
        title: String,
        jenisJurnal : String,
        routeInput : String,
        routeEdit : String,
        bpbmode : {
            default: 'bpb',
            type: String
        },
        canPrint: {
            default: true,
            type: Boolean
        },
        canEdit: {
            default: true,
            type: Boolean
        },
        canDelete: {
            default: true,
            type: Boolean
        },
        canUnposting: {
            default: true,
            type: Boolean
        },

    },
    data: function () {
      return {
        // eslint-disable-next-line
        dataAdapter: new jqx.dataAdapter(this.source, {
            formatData: function (data) {
                return  JSON.stringify(data);
            },
            beforeSend: function (jqxhr, settings) { 
                settings.xhrFields = {
                    withCredentials: true
                },
                jqxhr.setRequestHeader("X-XSRF-TOKEN",window.$cookies.get('XSRF-TOKEN'))
            }
        }),
        width: "100%",
        columns: [
          { text: 'Tgl', datafield: 'kirim_tgl', filtertype: 'range', width: '10%', cellsformat: 'dd-MM-yyyy' },
          { text: 'No Resi', datafield: 'kirim_no', width: '10%' },
          { text: 'Nama Pengirim', datafield: 'nama_pengirim', width: '10%'},
          { text: 'Asal', filtertype: 'list', filteritems: this.items, datafield: 'kab_asal', width: '10%'},
          { text: 'CASH / COD', filtertype: 'list', filteritems: this.items, datafield: 'bayar', width: '10%'},
          { text: 'Kabupaten Tujuan', filtertype: 'list', filteritems: this.items, datafield: 'kab_id', width: '10%'},
          { text: 'Kecamatan Tujuan', filtertype: 'list', filteritems: this.items, datafield: 'kec_id', width: '10%'},
          { text: 'Est Waktu', cellsformat: 'dd-MM-yyyy', datafield: 'leadtime', cellclassname: this.cellClass,  width: '10%'},
          { text: 'Status', filtertype: 'list', filteritems: this.items, datafield: 'statusKirim', width: '10%'},
          { text: 'Penerima',  datafield: 'penerima', width: '10%'},
        ],
        selectrow: 0,
        jenis: this.jenisJurnal,
        msgCetak: [],
        
      }
    },
    methods: {
        ready: function() {
            //this.$refs.myGrid.selectrow(0);
            //this.$refs.myGrid.focus();
        },
        cellClass: function (row, columnfield, value) {
                let rowvalue = this.$refs.myGrid.getrowdatabyid(row);
                let datenow = new Date()
                let est_date = rowvalue.leadtime
                let Difference_In_Time = est_date.getTime() - datenow.getTime();
                let Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
                if(rowvalue.status_kode == 11)
                        return '' 
                else {
                    if (Difference_In_Days == 1) {
                        return 'yellow';
                    }
                    else if (Difference_In_Days <= 0) {
                        return 'red'
                    }
                    else{
                        if(rowvalue.status_kode >= 1)
                            return 'green'
                    }
                }
             
        },
        inputForm: function(){
            this.$router.push({name : 'kiriminput'});
        },
        myGridOnContextMenu: function () {
                return false;
        },
        myGridOnRowClick: function (event) {
            if (event.args.rightclick) {
                this.$refs.myGrid.selectrow(event.args.rowindex);
                let scrollTop = window.scrollY;
                let scrollLeft = window.scrollX;
                this.$refs.myMenu.open(parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft, parseInt(event.args.originalEvent.clientY) + 5 + scrollTop);
                return false;
            }
        },
        myMenuOnItemClick: function (event) {
            let args = event.args;
            let rowindex = this.$refs.myGrid.getselectedrowindex();
            if (args.innerHTML == 'Edit') {
                this.editrow = rowindex;
                let dataRecord = this.$refs.myGrid.getrowdata(this.editrow)
                //console.log(dataRecord)
                let referensi = dataRecord.bpb_no
                //cek apakah sudah posting
                if(dataRecord.posting=='SUDAH POSTING'){
                    this.$vs.dialog({
                        color:"danger",
                        title: 'Error',
                        text: 'BPB TIDAK BISA DIEDIT KARENA SUDAH DI POSTING....',
                        'accept-text': 'Ya saya mengerti..'
                    })
                }
                else
                    this.$router.push({name : this.routeEdit, params: { ref: referensi }});
            }
            else if (args.innerHTML == 'Cetak') {
                this.editrow = rowindex;
                let dataRecord = this.$refs.myGrid.getrowdata(this.editrow)
                let referensi = dataRecord.kirim_no
                let self = this
                this.$http.get('/api/kirimcetak/'+referensi).then( resp => {
                    self.msgCetak = resp.data;
                    qz.websocket.connect().then(() => {
                        return qz.printers.find("LABEL");
                    }).then((printer) => {
                        let config = qz.configs.create(printer);
                        var data = self.msgCetak
                        data.map(item => {
                            let newitem = item + '\r\n'
                            self.dataCetak.push(newitem)
                        })
                        return qz.print(config, self.dataCetak);
                    }).then(() => {
                        return qz.websocket.disconnect();
                    }).then(() => {
                        process.exit(0);
                    }).catch((err) => {
                        console.error(err);
                        // process.exit(1);
                    });
                })
                
            }
            else if (args.innerHTML == 'UnPosting') {
                let rowid = this.$refs.myGrid.getrowid(rowindex)
                let data = this.$refs.myGrid.getrowdatabyid(rowid)
                if(data.posting=='BLM POSTING'){
                    this.$vs.dialog({
                        color:"danger",
                        title: 'Error',
                        text: 'BPB INI BELUM DIPOSTING, KENAPA JUGA HARUS UNPOSTING, TINGGAL EDIT SAJA BOS....',
                        'accept-text': 'Ya saya mengerti..'
                    })
                }
                else{
                    if(confirm("Anda dengan sadar atau diluar sadar akan unposting data ini, sudah yakin kah?")){
                        this.$http.post('/api/unpostingbpb',{
                                referensi : data.bpb_no
                        }).then(resp => {
                            //this.$refs.myGrid.updaterow(rowid,{posting: 'BLM POSTING'});
                            this.$refs.myGrid.updatebounddata();
                            this.$vs.notify({title:'BERHASIL..',text:'Data berhasil unposting..',color:'danger'})
                        }).catch(error => {
                            console.log(error);
                        })
                    }
                }
                
            }
            else {
                let rowid = this.$refs.myGrid.getrowid(rowindex)
                let data = this.$refs.myGrid.getrowdatabyid(rowid)
                if(data.posting=='SUDAH POSTING'){
                    this.$vs.dialog({
                        color:"danger",
                        title: 'Error',
                        text: 'MAAF BOS, BPB TIDAK BISA DIHAPUS KARENA SUDAH DI POSTING....',
                        'accept-text': 'Ya saya mengerti..'
                    })
                }
                else{
                    if(confirm("Yakin menghapus data?")){
                        this.$http.delete('/api/bpb/' + data.bpb_no).then(resp => {
                            console.log(resp)
                            this.$refs.myGrid.deleterow(rowid);
                            this.$vs.notify({title:'BERHASIL..',text:'Data berhasil dihapus..',color:'danger'})
                        }).catch(error => {
                            console.log(error);
                            this.$vs.notify({title:'GAGAL..',text:'Gagal hapus data..',color:'danger'})
                        })
                    }
                }
            }
        }
    },
    beforeCreate: function () {
      this.source = {
        datafields: [
          { name: 'kirim_no', type: 'string'},
          { name: 'kirim_tgl', type: 'date'},
          { name: 'nama_pengirim', type: 'string'},
          { name: 'alamat_penerima', type: 'string'},
          { name: 'bayar', type: 'string'},
          { name: 'kab_asal', map: 'kab_nama'},
          { name: 'kab_id', map: 'dkab_nama'},
          { name: 'kec_id', map: 'dkec_nama'},
          { name: 'leadtime', type: 'date'},
          { name: 'statusKirim', map: 'status_name'},
          { name: 'status_kode', map: 'status'},
          { name: 'penerima', type: 'string'},
        ],
        datatype: 'json',
        id: 'referensi',
        url: this.$urlbackend+'/api/operationkirim',
        type: 'post',
        deleterow: function (rowid, commit) {
            commit(true);
        }
      }
      this.editrow = -1;
    },
    created: function(){
        var self = this
        let processdata=function (data) {
            data.OFFICE = window.$cookies.get('OFFICE')
        }
        this.source.processdata = processdata
    }, 
    mounted: function () {
        document.addEventListener('contextmenu', event => event.preventDefault());
    },
    watch: {
        popupPdf: function(){
            if (this.popupPdf == false)
                this.pdfsrc = 'about:blank'
            else
                this.pdfsrc = this.pdfsrc + "#zoom=100"
        }
    }
  }
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>
<style lang="stylus">
.cetak
  height: 90vh
</style>
<style>
    .green {
        color: black\9;
        background-color: #779b1e\9;
    }
    .yellow {
        color: black\9;
        background-color: yellow\9;
    }
    .red {
        color: black\9;
        background-color: #e83636\9;
    }
    .green:not(.jqx-grid-cell-hover):not(.jqx-grid-cell-selected), .jqx-widget .green:not(.jqx-grid-cell-hover):not(.jqx-grid-cell-selected) {
        color: black;
        background-color: #779b1e;
    }
    .yellow:not(.jqx-grid-cell-hover):not(.jqx-grid-cell-selected), .jqx-widget .yellow:not(.jqx-grid-cell-hover):not(.jqx-grid-cell-selected) {
        color: black;
        background-color: yellow;
    }
    .red:not(.jqx-grid-cell-hover):not(.jqx-grid-cell-selected), .jqx-widget .red:not(.jqx-grid-cell-hover):not(.jqx-grid-cell-selected) {
        color: black;
        background-color: #e83636;
    }
</style>

